import { Link } from "react-router-dom";

import {
  FaHeartbeat,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

import "../../styles/components/Footer.css";

function Footer() {
  const currentYear =
    new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">

        {/* TOP FOOTER */}
        <div className="footer-grid">

          {/* BRAND */}
          <div className="footer-brand">
            <Link
              to="/"
              className="footer-logo"
            >
              <div className="footer-logo-icon">
                <FaHeartbeat />
              </div>

              <div className="footer-brand-text">
                <strong>
                  ZETH
                </strong>

                <span>
                  HEALTH
                </span>

                <small>
                  STAFFING INC.
                </small>
              </div>
            </Link>

            <p className="footer-description">
              Connecting qualified
              healthcare professionals
              with healthcare facilities
              across Canada.
            </p>

            <div className="footer-contact">
              <a href="mailto:info@zethhealth.ca">
                <FaEnvelope />

                <span>
                  info@zethhealth.ca
                </span>
              </a>

              <div>
                <FaMapMarkerAlt />

                <span>
                  Ontario, Canada
                </span>
              </div>
            </div>
          </div>

          {/* PROFESSIONALS */}
          <div className="footer-column">
            <h3>
              Professionals
            </h3>

            <Link to="/professional/login">
              Professional Login
            </Link>

            <Link to="/professional/register">
              Create an Account
            </Link>

            <a href="/#assignments">
              Browse Assignments
            </a>

            <Link to="/saved-jobs">
              Saved Jobs
            </Link>

            <a href="/#professionals">
              Why Join Zeth
            </a>
          </div>

          {/* FACILITIES */}
          <div className="footer-column">
            <h3>
              Facilities
            </h3>

            <Link to="/facility/login">
              Facility Login
            </Link>

            <Link to="/facility/register">
              Create Facility Account
            </Link>

            <a href="/#facilities">
              Request Staff
            </a>

            <a href="/#solutions">
              Staffing Solutions
            </a>
          </div>

          {/* COMPANY */}
          <div className="footer-column">
            <h3>
              Company
            </h3>

            <a href="/#about">
              About Zeth
            </a>

            <Link to="/news">
              Healthcare Hub
            </Link>

            <a href="/#contact">
              Contact Us
            </a>

            <Link
              to="/admin/login"
              className="footer-admin-link"
            >
              Admin Portal
            </Link>
          </div>
        </div>

        {/* BOTTOM FOOTER */}
        <div className="footer-bottom">
          <p>
            © {currentYear} Zeth Health
            Staffing Inc. All rights
            reserved.
          </p>

          <div className="footer-legal">
            <a href="/privacy">
              Privacy Policy
            </a>

            <a href="/terms">
              Terms of Use
            </a>

            <a href="/accessibility">
              Accessibility
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;